import Swiper, { Navigation } from 'swiper';

Swiper.use(Navigation);
export default class ContactBoxes {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.slider = this.root.querySelector('[data-contact-boxes-swiper]');
        this.prevEl = this.root.querySelector(
            '.contact-boxes__arrow-desktop--prev'
        );
        this.nextEl = this.root.querySelector(
            '.contact-boxes__arrow-desktop--next'
        );
        this.sliderInstance = null;

        return true;
    }

    init() {
        this.initSlider();
    }

    initSlider() {
        if (!this.slider) return;

        this.sliderInstance = new Swiper(this.slider, {
            slidesPerView: 'auto',
            spaceBetween: 24,
            navigation: {
                prevEl: this.prevEl,
                nextEl: this.nextEl,
            },
        });
    }
}
